import api from "../../../axiosConfig";

export const fetchAsignaciones = () => {
  return api.get("/vehiculo-conductores");
};

export const fetchVehiculos = () => {
  return api.get("/vehiculos");
};

export const fetchConductores = () => {
  return api.get("/conductores");
};

export const fetchZonas = () => {
  return api.get("/vehiculo-conductores/zonas-disponibles");
};

export const crearAsignacion = (asignacion, usuarioId) => {
  return api.post("/vehiculo-conductores", {
    ...asignacion,
    usuario_id: usuarioId
  })
};

export const eliminarAsignacion = (id, usuarioId) => {
  return api.delete(`/vehiculo-conductores/${id}`, {
    data: {
      usuario_id: usuarioId
    }
  });
};

export const fetchHistorialAsignaciones = (params = {}) => {
  return api.get("/vehiculo-conductores/historial", { params });
};

export const crearPaciente = (paciente, usuarioId) => {
  return api.post("/pacientes", {
    ...paciente,
    usuario_id: usuarioId
  });
};

export const actualizarPaciente = (id, paciente, usuarioId) => {
  return api.put(`/pacientes/${id}`, {
    ...paciente,
    usuario_id: usuarioId
  });
};

export const eliminarPaciente = (id, usuarioId) => {
  return api.delete(`/pacientes/${id}`, {
    data: {
      usuario_id: usuarioId
    }
  });
};

